module.exports = __webpack_public_path__ + "images/recycling-bin.svg";